export default __webpack_public_path__ + "static/media/Slide-1.bdbc2d9b.png";